export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Avevo paura del coreano. Tutti quei simboli mi sembravano impossibili. Dopo il giorno 5 con Coreano Expresso, sono riuscita a leggere la mia prima frase in Hangeul senza aiuto. Alla settimana 3 guardavo i K-Drama e capivo le parole vere. Questo sistema ha cambiato completamente la mia vita.',
    name: 'Maria G.',
    location: 'Roma · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      'Guardavo i K-Drama da 2 anni frustrato perché non capivo NIENTE. Ho provato una app per 6 mesi senza progressi reali. Il metodo Coreano Expresso funziona davvero. Ora sono nella community Discord a parlare con coreani autentici.',
    name: 'Luca M.',
    location: 'Milano · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      "Avevo paura di non essere 'portata per le lingue'. Coreano Expresso mi ha dimostrato il contrario. Il metodo visivo rende tutto così chiaro. Ho sentito progressi DAL PRIMO GIORNO, e questo mi ha motivata. Lo consiglio a tutti i fan del K-Pop che conosco.",
    name: 'Giulia R.',
    location: 'Napoli · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Le flashcard ora vivono nel mio telefono. Ripasso l’Hangeul in autobus e leggo già i menù e i cartelli nei K-Drama prima che compaiano i sottotitoli.',
    name: 'Lucia M.',
    location: 'Torino · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      'Hangeul Express ce l’ha fatta in due serate. Avevo provato tre volte prima con i video e avevo sempre abbandonato. Vedere i blocchi sillabici spiegati visivamente ha finalmente fatto clic.',
    name: 'Marco R.',
    location: 'Bologna · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'Il calendario da 60 minuti è ciò che mi ha reso costante. 60 minuti al giorno, senza dubbi su cosa studiare. Il giorno 55 ho inviato il mio primo messaggio in coreano a un amico a Seoul.',
    name: 'Federico P.',
    location: 'Venezia · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
  {
    quote:
      'L’ho comprato per i testi K-Pop e sono rimasta per la community. Su Discord ci sono madrelingua che correggono la tua pronuncia. Vale decisamente più di 27€.',
    name: 'Chiara Z.',
    location: 'Firenze · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
